// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { ITraceTelemetry, SeverityLevel } from '@microsoft/applicationinsights-web';

export function createTraceEvent(message: string, info: any = {}, severityLevel: SeverityLevel = SeverityLevel.Information): ITraceTelemetry {
    return {
        message,
        severityLevel,
        properties: {
            ...info,
            isError: severityLevel === SeverityLevel.Error || severityLevel === SeverityLevel.Critical,
        },
    }; 
}
